/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_CUSTOMIZATION = gql`
   query customization {
     customization  {
       language
     }
   }
 `;
